import { useSessionStore } from "~/stores/session";

export default defineNuxtRouteMiddleware(async () => {
  const session = useSessionStore();
  await session.restoreSession();

  if (!session.isAuthenticated) return navigateTo("/auth/login");
  if (!session.isAdmin) return navigateTo("/app");
});
